import { useState, Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./private-route";
import { privateRoutes } from "./route-list";
import NotFound from "../pages/not-found";
import FloatingLoader from "../pages/layout/floatLoader";

import ScrollToTop from "../components/ScrollToTop";
import { useSelector } from "react-redux";

function DefaultRoutes() {
  const [isLoading, setIsLoading] = useState(true);
  const profileLoading = useSelector((state) => state.getProfile.loading);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [profileLoading]);

  if (profileLoading || isLoading) {
    return <FloatingLoader />;
  }

  return (
    <section className="page h-100">
      {/* <PreloadImages
        staticImages={[...LoginSignUpStaticImages, ...SidebarStaticIcons]}
        dynamicImageLists={[
          { list: casinoProviders, key: "image_url" },
          { list: banners, key: "image" },
        ]}
        onComplete={() => {
          console.log("🚀 All images preloaded");
        }}
      /> */}

      <Suspense fallback={<FloatingLoader />}>
        <ScrollToTop />
        <Routes>
          <Route path="*" element={<NotFound />} />

          {privateRoutes.map((itm, index) => (
            <Route
              key={index}
              path={itm.path}
              exact
              isAuthProtected={itm.isAuthProtected}
              element={
                <PrivateRoute
                  name={itm.path}
                  path={itm.path}
                  component={itm?.layout}
                  element={itm?.layout}
                  isAuthProtected={itm.isAuthProtected}
                />
              }
            />
          ))}
        </Routes>
      </Suspense>
    </section>
  );
}

export default DefaultRoutes;
